
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from './config/config.service';
import { HttpService } from './http-service';
import { timeout, map, catchError } from 'rxjs/operators';

@Injectable()
export class UserProfileService extends HttpService {

  constructor(
    private http: HttpClient,
    private config: ConfigService) { super(); }

  public getUserProfile() {
    return this.http.get(this.getUri())
      .pipe(
        timeout(59000),
        map(super.extractData),
        catchError(this.handleError.bind(this))
      );
  }
  private getUri(): string {
    const officeConfigData = this.config.getConfig('office');
    let url = this.getAPIEndPoint(this.config.arpOrigin, this.config.arpUsap, officeConfigData.apiEndPoint) +
              this.concealSAP(this.config.arpUsap, this.config.getOffUsap()) + 'v1/home_page_security';
    return url;
  }
}